"use client";

import Link, { type LinkProps } from "next/link";
import { PropsWithChildren } from "react";

type Props = {
  link?: Pick<LinkProps, "href" | "onClick">;
};

export const NavigationLink = ({
  children,
  link,
  ...rest
}: PropsWithChildren<Props>) => {
  if (link) {
    return (
      <Link {...link} {...rest}>
        {children}
      </Link>
    );
  }

  return <>{children}</>;
};
